import { SectionSkeletonComponent } from './section-skeleton.component';

export default angular
  .module('sfMobile.components.section-skeleton', [
    'sfMobile.components.title-skeleton',
    'sfMobile.components.list-items-skeleton',
  ])
  .component('sfSectionSkeleton', SectionSkeletonComponent).name;
